<div class="flex gap-4">
  <div class="type">
    <app-icon class="icon" [name]="iconName" size="custom"></app-icon>
    <p class="text-sm">{{text}}</p>
  </div>
  <div class="flex flex-col items-end">
    <p class="text-sm">
      {{description}}
    </p>
    <p *ngIf="!disabled" class="text-sm text-[#e8540f] mt-4 cursor-pointer hover:underline"
       (click)="selectType(type)">{{'common.buttons.choose' | transloco}}</p>
    <p *ngIf="disabled" class="text-sm text-[#e8540f] mt-4 cursor-pointer hover:underline"
       (click)="redirectToVerification()">
      {{'common.buttons.exboLinkingRequired' | transloco}}</p>
  </div>
</div>
